
<div class="container mt-2" style="height: 97%;">
    <div class="row" style="height: 100%;">
      <div class="col">
        <!-- Usuario -->
        <div class="user-icon">
            <button (click)="openNav(subMenuValues.USER_INFO)" mat-button>
                <mat-icon>person</mat-icon>
            </button>
        </div>

        <div *ngIf="hasOrganizationSelected" class="col mt-5" style="color: rgb(27, 42, 103);">
            <!-- Servicios -->
            <div class="row mt-3">
                <div class="d-flex flex-column align-items-center justify-center">
                    <button (click)="openNav(subMenuValues.FLUJOS_CREDITO)" mat-button color="secondary" [ngClass]="{'selected-icon' : selectedSubMenu == subMenuValues.FLUJOS_CREDITO}">
                        <mat-icon>route</mat-icon>
                    </button>
                    <label class="text-center">Flujos</label>
                </div>
            </div>
            <div class="row mt-3">
                <div class="d-flex flex-column align-items-center justify-center">
                    <button (click)="openNav(subMenuValues.SERVICIOS)" mat-button color="secondary" [ngClass]="{'selected-icon' : selectedSubMenu == subMenuValues.SERVICIOS}">
                        <mat-icon>stars</mat-icon>
                    </button>
                    <label class="text-center">Reportes</label>
                </div>
            </div>
            <div class="row mt-3">
                <div class="d-flex flex-column align-items-center justify-center">
                    <button (click)="setSelected(subMenuValues.ADMIN_CARTERA)" [routerLink]="['administracion-cartera']" mat-button color="secondary" [ngClass]="{'selected-icon' : selectedSubMenu == subMenuValues.ADMIN_CARTERA}">
                        <mat-icon>work</mat-icon>
                    </button>
                    <label class="text-center">Admin.<br> de cartera</label>
                </div>
            </div>
            <div class="row mt-3">
                <div class="d-flex flex-column align-items-center justify-center">
                    <button (click)="setSelected(subMenuValues.CESION)" [routerLink]="['reportes/monitoreo-cesion-facturas']" mat-button color="secondary" [ngClass]="{'selected-icon' : selectedSubMenu == subMenuValues.CESION}">
                        <mat-icon>receipt</mat-icon>
                    </button>
                    <label class="text-center">Monitoreo<br>cesión<br> facturas</label>
                </div>
            </div>
            <div class="row mt-3">
                <div class="d-flex flex-column align-items-center justify-center">
                    <button (click)="setSelected(subMenuValues.OFERTAS)" [routerLink]="['ofertas-financieras']" mat-button color="secondary" [ngClass]="{'selected-icon' : selectedSubMenu == subMenuValues.OFERTAS}">
                        <mat-icon>paid</mat-icon>
                    </button>
                    <label class="text-center">Ofertas<br>financieras</label>
                </div>
            </div>
            <div class="row mt-3">
                <div class="d-flex flex-column align-items-center justify-center">
                    <button (click)="openNav(subMenuValues.MOROSOS)" mat-button color="secondary" [ngClass]="{'selected-icon' : selectedSubMenu == subMenuValues.MOROSOS}">
                        <mat-icon>payments</mat-icon>
                    </button>
                    <label class="text-center">Publicación<br>morosos</label>
                </div>
            </div>
            <!-- Grupos -->
            <div class="row mt-3">
                <div class="d-flex flex-column  align-items-center justify-center text-center" style="max-width: 70px">
                    <button (click)="openNav(subMenuValues.GRUPOS)" [ngClass]="{'selected-icon' : selectedSubMenu == subMenuValues.GRUPOS}" mat-button color="tertiary">
                        <mat-icon>people</mat-icon>
                    </button>
                    <label class="text-center">Usuarios y Grupos</label>
                </div>
            </div>  
            <!-- ajustes -->
            <div class="row mt-3">
                <div class="d-flex flex-column align-items-center justify-center">
                    <button (click)="openNav(subMenuValues.AJUSTES)" [ngClass]="{'selected-icon' : selectedSubMenu == subMenuValues.AJUSTES}" mat-button>
                        <mat-icon style="color: rgb(27, 42, 103);">settings</mat-icon>
                    </button>
                    <label class="text-center">Ajustes</label>
                </div>
            </div>
            <div class="row mt-3">
                <div class="d-flex flex-column align-items-center justify-center">
                    <button (click)="setSelected(subMenuValues.MONITOREO_SERVICIOS)" [routerLink]="['estado-servicios']" mat-button color="secondary" [ngClass]="{'selected-icon' : selectedSubMenu == subMenuValues.MONITOREO_SERVICIOS}">
                        <mat-icon
                            fontSet="material-symbols-outlined"
                            matBadge="0"
                            [matBadgeHidden]="!(hasServiceErrors$ | async)"
                            matBadgeColor="warn"
                            matBadgeOverlap="true"
                            class="hide-text icon-filled"
                            aria-hidden="false"
                            aria-label="Estado de servicios con alertas">
                            cardiology
                        </mat-icon>
                    </button>
                    
                    <label class="text-center">Estado<br>servicios</label>
                </div>
            </div>
        </div>
        <!-- <button (click)="sidenavInner.toggle()">open</button> -->
      </div>
      <!-- <div class="col"> -->
          <mat-sidenav-container class="example-container">
              <mat-sidenav #sidenavInner mode="side">
                  <div style="width:300px; height: 100%">
                    <div *ngIf="this.selectedSubMenu == subMenuValues.USER_INFO">
                        <div *ngIf="userInfo">
                            <div class="sidebar-user-name">{{userInfo.name + ' ' + userInfo.given_name}}</div>
                            <div class="sidebar-user-links" *ngIf="hasOrganizationSelected">
                                {{organization}}
                            </div>
                            <div class="sidebar-user-links">
                                <ul class="list-inline">
                                <button mat-button *ngIf="hasManyOrganization" (click)="swithOrganization()" class="mt-2">
                                    Cambiar de Organización <i class="fa fa-exchange"></i>
                                </button>
                                <!--<button mat-button (click)="goToMfaConfiguracion()" class="mt-2">
                                    <span class="d-flex align-items-center justify-content-between w-100">
                                        <span class="d-flex align-items-center">
                                            <span>Configuración MFA</span>
                                        </span>
                                        <mat-icon fontIcon="key" class="ml-3"></mat-icon>
                                    </span>
                                </button>-->
                                <button mat-button (click)="logout()">
                                    Cerrar sesión <i class="gi gi-exit"></i>
                                </button>
                                <!-- <li *ngIf="hasManyOrganization" (click)="swithOrganization()" data-toggle="tooltip" data-placement="bottom" title="Cambiar de organizacion"><i class="fa fa-exchange"></i></li> -->
                                <!-- <li data-toggle="tooltip" data-placement="bottom" title="{{userInfo.email}}"><i class="gi gi-envelope"></i></li>
                                <li *ngIf="userInfo.phoneNumber" data-toggle="tooltip" data-placement="bottom" [title]="userInfo.phoneNumber"><i class="gi gi-phone_alt"></i></li> -->
                                <!-- <li (click)="logout()" data-toggle="tooltip" data-placement="bottom" title="Cerrar sesion"><i class="gi gi-exit"></i></li> -->
                            </ul>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let option of currentSubMenuOptions">
                        <mat-accordion *ngIf="option.group && option.hasAccess">
                            <ng-container  *ngIf="validateByLabel(option.label); else requestAccess">
                                <mat-expansion-panel hideToggle>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title><i class="{{option.icon}} sidebar-nav-icon mr-2"></i>  {{ option.label }} </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>
                                        <div *ngFor="let groupOption of option.group">
                                        <button *ngIf="!groupOption.group && !groupOption.actions && groupOption.hasAccess" (click)="sidenavInner.toggle()" [routerLink]="[groupOption.url]" style="justify-content: flex-start;" class="sub-button" mat-button>
                                            <!-- <mat-icon class="mr-3">settings</mat-icon> -->
                                            <i class="{{groupOption.icon}} sidebar-nav-icon"></i>
                                            {{ groupOption.label }}
                                        </button>
                                        <button *ngIf="!groupOption.group && groupOption.actions && groupOption.hasAccess" [matMenuTriggerFor]="groupMenu" style="justify-content: flex-start;" class="sub-button" mat-button>
                                            <!-- <mat-icon class="mr-3">settings</mat-icon> -->
                                            <i class="{{groupOption.icon}} sidebar-nav-icon"></i>
                                            {{ groupOption.label }}
                                        </button>
                                        <mat-menu #groupMenu="matMenu">
                                            <button *ngFor="let groupAction of groupOption.actions" mat-menu-item [routerLink]="[groupAction.url]" (click)="sidenavInner.toggle()">
                                                {{ groupAction.label }}
                                            </button>
                                        </mat-menu>
                                        </div>
                                    </ng-template>
                                </mat-expansion-panel>
                            </ng-container>
                            <ng-template #requestAccess>
                                <mat-expansion-panel hideToggle #requestAccessPanel (click)="goToRequestAccess()">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title><i class="{{option.icon}} sidebar-nav-icon mr-2"></i>  {{ option.label }} </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent></ng-template>
                                </mat-expansion-panel>
                            </ng-template>
                        </mat-accordion>
                          
                        <button *ngIf="!option.group && !option.actions && option.hasAccess" (click)="sidenavInner.toggle()" [routerLink]="[option.url]" style="justify-content: flex-start; padding: 0 24px;" class="sub-button" mat-button>
                            <!-- <mat-icon class="mr-3">settings</mat-icon> -->
                            <i class="{{option.icon}} sidebar-nav-icon"></i>
                            {{ option.label }}
                        </button>
                        <button *ngIf="!option.group && option.actions && option.hasAccess" [matMenuTriggerFor]="menu" style="justify-content: flex-start; padding: 0 24px;" class="sub-button" mat-button>
                            <!-- <mat-icon class="mr-3">settings</mat-icon> -->
                            <i class="{{option.icon}} sidebar-nav-icon"></i>
                            {{ option.label }}
                        </button>
                        <mat-menu #menu="matMenu">
                            <button *ngFor="let action of option.actions" mat-menu-item [routerLink]="[action.url]" (click)="sidenavInner.toggle()">
                                {{ action.label }}
                            </button>
                        </mat-menu>
                    </div>
                  </div>
              </mat-sidenav>
              <mat-sidenav-content>
                  <div></div>
              </mat-sidenav-content>
          </mat-sidenav-container>
      <!-- </div> -->
    </div>
</div>
